/**
 * Utilities for component templates
 */
import { ASSETS_HOST } from "replo-utils/lib/assets";

/**
 * Optimizes image URLs using Cloudflare image resizing if the image is hosted on Replo CDN
 * Based on Cloudflare image resizing URL syntax as implemented in the Cloudflare worker
 * @param url The original image URL
 * @param options Configuration options for image optimization
 * @returns The optimized image URL or the original URL if optimization isn't applicable
 */
export function getOptimizedImageUrl(
  url: string | undefined,
  options: {
    width?: number;
    height?: number;
    fit?: "scale-down" | "contain" | "cover" | "crop" | "pad";
  } = {},
): string {
  if (!url) {
    return "";
  }

  const isReploCdn = url.includes(ASSETS_HOST);
  if (!isReploCdn) {
    return url;
  }

  try {
    const urlObj = new URL(url);
    const searchParams = new URLSearchParams();

    if (options.width) {
      searchParams.append("width", options.width.toString());
    }

    if (options.height) {
      searchParams.append("height", options.height.toString());
    }

    if (options.fit) {
      searchParams.append("fit", options.fit);
    }

    if (searchParams.toString() === "") {
      return url;
    }

    return `${urlObj.origin}${urlObj.pathname}?${searchParams.toString()}`;
  } catch (error) {
    console.error("Error creating optimized image URL:", error);
    return url;
  }
}
